var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fotos.loading,
          expression: "fotos.loading"
        }
      ],
      staticClass: "container-fotos"
    },
    [
      _vm.base64
        ? _c("AppModalVisualizaPdf", {
            attrs: {
              titulo: "Foto",
              base64: _vm.base64,
              isImagem: true,
              showFooter: false
            },
            on: {
              closeModal: function() {
                return (_vm.base64 = null)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.fotos.srcList, function(foto, index) {
        return _c("div", { key: index, staticClass: "card-foto" }, [
          _c(
            "div",
            { staticClass: "display-foto" },
            [
              _c("el-image", {
                staticStyle: { width: "200px", height: "115px" },
                attrs: { fit: "scale-down", src: foto.base64 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "acoes-foto" }, [
            _c(
              "div",
              {
                staticClass: "acao-button",
                on: {
                  click: function($event) {
                    return _vm.baixar(foto)
                  }
                }
              },
              [_vm._m(0, true)]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "acao-button",
                on: {
                  click: function($event) {
                    return _vm.visualizar(foto)
                  }
                }
              },
              [_vm._m(1, true)]
            )
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", [_c("i", { staticClass: "fas fa-download" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", [
      _c("i", { staticClass: "material-icons" }, [_vm._v("visibility")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b2ab0b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2ab0b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Galeria/components/GridFotos.vue
// module id = null
// module chunks = 